import { FC, useEffect } from "react";
import { Box, Typography, Button, Paper } from "@material-ui/core";
import { useStyles } from "./style";
import Loader from "router/components/Loader";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { getDaFeedbackReportData } from "actions/daFeedbackActions";
import { useDispatch } from "react-redux";
import { useNav } from "hooks/useNav";
import {
  WeeklyScheduleFeedbackStatus,
  SelectScheduleDates,
} from "./ActionComponents/SelectScheduleDates";
import {
  DailyShiftAttenanceStatus,
  SelectShiftAttenance,
} from "./ActionComponents/SelectShiftAttendance";
import { updateNotifications } from "actions/notificationsActions";

interface PropsType {}

const DaFeedbackReport: FC<PropsType> = () => {
  const { id } = useNav().pageParams;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { viewDaFeedback } = useNav();
  const { loadingData, currentReport } = useTypeSelectors((state) => state.daFeedbackTable);
  const { notificationsList } = useTypeSelectors((state) => state.daNotificationsState);

  useEffect(() => {
    if (id) {
      dispatch(getDaFeedbackReportData(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    const notification = notificationsList.find(
      (notify) => Number(notify.post_id) === currentReport?.id,
    );
    if (id === currentReport?.id && notification && !notification.is_read) {
      dispatch(updateNotifications(notification.id, () => null));
    }
  }, [currentReport, notificationsList, id, dispatch]);

  return (
    <Box className={classes.root}>
      <Loader isLoading={loadingData} />
      <Paper
        className={classes.paper}
        style={{ display: "flex", gap: 10, justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Button variant="outlined" onClick={viewDaFeedback}>
          Back
        </Button>
      </Paper>
      <Paper className={classes.paper}>
        <Box className={classes.topContent}>
          <Box>
            <Typography style={{ fontWeight: 700, fontSize: 18 }}>
              {currentReport?.title}
            </Typography>
            <Typography style={{ whiteSpace: "pre-line" }}>{currentReport?.content}</Typography>
          </Box>
          {currentReport?.type === 2 && <DailyShiftAttenanceStatus currentReport={currentReport} />}
          {currentReport?.type && [3, 4].includes(currentReport?.type) ? (
            <WeeklyScheduleFeedbackStatus currentReport={currentReport} />
          ) : (
            ""
          )}
        </Box>
        {currentReport?.type === 2 && <SelectShiftAttenance currentReport={currentReport} />}
        {currentReport?.type && [3, 4].includes(currentReport?.type) ? (
          <SelectScheduleDates currentReport={currentReport} />
        ) : (
          ""
        )}
      </Paper>
    </Box>
  );
};

export default DaFeedbackReport;
